var map = {
	"./en": [
		790,
		790
	],
	"./en.json": [
		790,
		790
	],
	"./pl": [
		5143
	],
	"./pl.json": [
		5143
	],
	"./ru": [
		9672,
		9672
	],
	"./ru.json": [
		9672,
		9672
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 912;
module.exports = webpackAsyncContext;